"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = __importStar(require("react"));
var draft_js_1 = require("draft-js");
var Draft_1 = require("./Draft");
var layout_1 = require("../../layout");
var RichTextEditorToolbar_1 = __importDefault(require("./RichTextEditorToolbar"));
var variables_1 = require("../../../style/variables");
var getBlockStyle = function (block) {
    if (block.getType() === 'unordered-list-item') {
        return Draft_1.listStyles.listItem;
    }
    else {
        return Draft_1.listStyles.numberedList;
    }
};
var BaseEditor = draft_js_1.Editor;
var RichTextEditor = function (_a) {
    var _b = _a.value, value = _b === void 0 ? draft_js_1.EditorState.createEmpty() : _b, onChange = _a.onChange, props = __rest(_a, ["value", "onChange"]);
    var editorRef = react_2.useRef(null);
    var onChangeHandler = function (edtrState) {
        onChange === null || onChange === void 0 ? void 0 : onChange(edtrState);
    };
    var focusEditor = function () { var _a; return (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.focus(); };
    var handleKeyCommand = function (command, edtrState) {
        var newState = draft_js_1.RichUtils.handleKeyCommand(edtrState, command);
        if (newState) {
            onChange === null || onChange === void 0 ? void 0 : onChange(newState);
            return 'handled';
        }
        return 'not-handled';
    };
    var mapKeyToEditorCommand = function (e) {
        if (e.key === 'tab' /* TAB */) {
            var newEditorState = draft_js_1.RichUtils.onTab(e, value, 4);
            if (newEditorState !== value) {
                onChange === null || onChange === void 0 ? void 0 : onChange(newEditorState);
            }
            return null;
        }
        return draft_js_1.getDefaultKeyBinding(e);
    };
    var displayPlaceholder = function () {
        var contentState = value.getCurrentContent();
        return !contentState.hasText() && contentState.getBlockMap().first().getType() !== 'unstyled';
    };
    var toggleStyle = function (toggle_style, toggleType) {
        if (toggleType === 'block') {
            onChange === null || onChange === void 0 ? void 0 : onChange(draft_js_1.RichUtils.toggleBlockType(value, toggle_style));
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange(draft_js_1.RichUtils.toggleInlineStyle(value, toggle_style));
        }
    };
    return (react_1.jsx(react_2.default.Fragment, null,
        react_1.jsx(layout_1.Flex, { direction: "column", css: [
                Draft_1.draftStyle,
                {
                    border: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
                    borderRadius: 6,
                },
            ] },
            !props.readOnly && (react_1.jsx(RichTextEditorToolbar_1.default, { actions: props.actions, editorState: value, onEditorStateChanged: toggleStyle, disabled: props.disabled })),
            react_1.jsx("div", { css: { padding: 16 }, onClick: focusEditor },
                react_1.jsx(BaseEditor, { editorState: value, onChange: onChangeHandler, blockStyleFn: getBlockStyle, handleKeyCommand: handleKeyCommand, keyBindingFn: mapKeyToEditorCommand, ref: editorRef, placeholder: !displayPlaceholder() ? 'Enter a description...' : undefined, spellCheck: true, readOnly: props.disabled || props.readOnly })))));
};
exports.default = RichTextEditor;
